<template>
  <div
      class="mc-title"
      :class="{
        'is-h1':type === 'h1',
        'is-h2':type === 'h2',
        'is-back': type === 'back'
      }"
      @click.stop="_click"
  >
    <h1 class="mc-title__h1"><slot></slot></h1>
  </div>
</template>
<script type="text/ecmascript-6">
  export default{
    name: 'base-title',
    props:{
      // h1 h2
      type : {
        type: String,
        defalut: 'title'
      }
    },
    methods:{
      _click(){
        if(this.type === 'back') {
          this.$emit('click')
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/base-title.vue